import { Box, CircularProgress, Typography } from "@mui/material";
import React from "react";
import {
  BppCardBgIconDown,
  BppCardBgIconUp,
  BppMercuryAlertIcon,
} from "../../assets/Icon/BppIcon";
import CustomButton from "../common-components/CustomButton";
import ListLoadingNew from "../common-components/ListLoadingNew";
import ListLoading from "../common-components/ListLoading";

const BppCard = ({
  img,
  description,
  mercuryAlert = false,
  handleClick,
  title,
  loadingType,
  handleKnowMoreClick,
  isKnow,
}: {
  img: string;
  description: string;
  mercuryAlert?: boolean;
  handleClick?: () => void;
  title?: string;
  handleKnowMoreClick?: () => void;
  isKnow?: boolean;
  loadingType?: any;
}) => {
  return (
    <Box
      sx={{
        backgroundColor: "#f8f9fa",
        padding: "12px",
        position: "relative",
      }}
    >
      {/* Main Title */}

      {/* Brex Card */}
      <Box
        sx={{
          backgroundColor: "#ffffff",
          borderRadius: "10px",
          borderTopLeftRadius: "20px",
          borderBottomRightRadius: "20px",
          padding: "2rem",
          display: "flex",
          flexDirection: "row",
          alignItems: "flex-start",
          gap: "2rem",
          position: "relative",
          // maxWidth: "800px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        {/* Background Icons */}
        <Box sx={{ position: "absolute", bottom: -6, right: 0 }}>
          <BppCardBgIconDown />
        </Box>
        <Box sx={{ position: "absolute", top: -2, left: 0 }}>
          <BppCardBgIconUp />
        </Box>

        {/* Brex Logo Section */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "30px",
            flexWrap: "wrap",
          }}
        >
          <Box
            sx={{
              border: "1px solid #EAF1FA",

              borderRadius: "10px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "20px",
              backgroundColor: "#ffffff",
              minWidth: "120px",
              minHeight: "120px",
              objectFit: "cover",
            }}
          >
            <img
              src={img}
              alt="brex-logo"
              style={
                !mercuryAlert
                  ? { width: "60px", height: "60px" }
                  : { width: "70px", height: "70px" }
              }
            />
          </Box>

          {/* Content Section */}

          <Box sx={{ flex: 1 }}>
            <Typography
              variant="body1"
              sx={{
                lineHeight: 1.6,
                marginBottom: "20px",
                fontSize: "16px",
                fontWeight: 400,
                color: "#6C6F71",
              }}
            >
              {description}
            </Typography>
            {mercuryAlert ? (
              <div style={{ cursor: "pointer" }}>
                <BppMercuryAlertIcon />
              </div>
            ) : (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: "1rem",
                  flexWrap: "wrap",
                }}
              >
                <CustomButton
                  btnTitle={
                    loadingType === "mercury" ? (
                      <CircularProgress
                        size={24}
                        sx={{
                          "& svg": {
                            stroke: "url(#gradientColor)",
                          },
                        }}
                      />
                    ) : (
                      title
                    )
                  }
                  minwidth="152px"
                  sx={{ height: "43px" }}
                  disabled={loadingType === "mercury"}
                  iswidthInmobile
                  handleClick={() => {
                    handleClick?.();
                  }}
                />
              </Box>
            )}
          </Box>
        </div>
      </Box>
    </Box>
  );
};

export default BppCard;
